import React from 'react';
import JobRow from './JobRow';
import './JobList.css';

const JobList = ({ jobs, onEdit, onDelete }) => {
  return (
    <table className="adminjob-list">
      <thead>
        <tr>
          <th>Title</th>
          <th>Company</th>
          <th>Location</th>
          <th>Experience</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {jobs.map(job => (
          <JobRow key={job.id} job={job} onEdit={onEdit} onDelete={onDelete} />
        ))}
      </tbody>
    </table>
  );
};

export default JobList;
